import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import uiReducer from "../feature/ui/uiSlice";

import { mainApi, mainApiLogout } from "./services/mainApiSlice";
import { otpApi } from "./services/otpApiSlice";
import { setupListeners } from "@reduxjs/toolkit/dist/query";

export const store = configureStore({
  reducer: {
    ui: uiReducer,

    [mainApi.reducerPath]: mainApi.reducer,
    [mainApiLogout.reducerPath]: mainApiLogout.reducer,
    [otpApi.reducerPath]: otpApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    mainApi.middleware,
    mainApiLogout.middleware,
    otpApi.middleware
  ),
});

setupListeners(store.dispatch);
export default store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
